import reactStringReplace from 'react-string-replace';

const options = [
  {
    value: ':name:',
    label: 'Client Name',
  },
  {
    value: ':associate:',
    label: 'Associate Name',
  },
  {
    value: ':assigned_associate_name:',
    label: 'Associate Name',
  },
  {
    value: ':review:',
    label: 'Review Link',
  },
  {
    value: ':store:',
    label: 'Store Name',
  },
  {
    value: ':merchant_name:',
    label: 'Merchant Name',
  },
  {
    value: ':category:',
    label: 'Product Category',
  },
  {
    value: ':product:',
    label: 'Product Name',
  },
  {
    value: ':relation_name:',
    label: 'Relationship Name',
  },
  {
    value: ':appointment_date:',
    label: 'Appointment Date',
  },
  {
    value: ':appointment_time:',
    label: 'Appointment Time',
  },
  {
    value: ':kiosk_link:',
    label: 'Appointment Link',
  },
];

export const convertMessageTemplate = messageTemplate => {
  const regex = new RegExp(`(${options.map(t => t.value).join('|')})`);
  const splitString = reactStringReplace(messageTemplate, regex, (match, i) => {
    const find = options.find(t => t.value === match);
    if (find) {
      return `<span class="ant-tag-clientbook" contentEditable="false">${find.label}</span>`;
    }
    return match;
  });
  return splitString.join('');
};
